import type { FaqItem } from '../model/types';

export const faqItems: FaqItem[] = [
  {
    question: '기획서가 없어도 문의할 수 있나요?',
    answer:
      '네. 만들고 싶은 서비스나 해결하려는 문제를 가능한 한 자세히 알려주세요. 서비스·SaaS·솔루션 개발, 웹·앱과 업무 시스템 구축, AI 통합·업무 혁신(AX), 기존 시스템 개선 가운데 어떤 형태를 검토하고 있는지도 적어주세요. 현재 상황과 필요한 기능, 사용 중인 시스템, 참고 자료도 도움이 됩니다. 희망 일정과 예산까지 함께 보내주시면 내용을 확인한 뒤 필요한 범위와 진행 방법을 정리합니다.',
  },
  {
    question: '비용과 일정은 어떻게 정해지나요?',
    answer:
      '비용과 일정은 기능 범위, 외부 연동, 데이터 이전, 검토 절차, 운영 조건을 확인한 뒤 산정합니다. 생각해 둔 예산이나 희망 일정이 있다면 문의할 때 함께 적어주세요.',
  },
  {
    question: '운영 중인 서비스나 시스템도 맡길 수 있나요?',
    answer:
      '가능합니다. 새로 구축한 서비스의 배포 후 운영뿐 아니라 이미 사용 중인 웹·앱, SaaS, 업무 시스템과 솔루션도 유지보수할 수 있습니다. 배포·인프라 관리, 모니터링과 오류 대응, 기능 개선, 정기 점검, 기술 부채 정리와 인수인계 등 현재 환경에 필요한 범위를 정합니다.',
  },
  {
    question: '기존 시스템이나 외부 서비스와 연동할 수 있나요?',
    answer:
      '가능합니다. 현재 사용 중인 업무 시스템과 데이터 구조를 확인한 뒤 API, 인증, 결제, 알림, 외부 SaaS 가운데 어떤 대상을 어떻게 연결할지 정리합니다. 운영에 미치는 영향과 데이터 이전 범위까지 살펴 현재 환경에 맞는 연동 방식을 제안합니다.',
  },
  {
    question: 'AI 기능은 어떤 방식으로 도입하나요?',
    answer:
      '서비스의 목적과 데이터 환경을 먼저 확인해 어떤 AI 기능을 어디에 적용할지 정합니다. 문서 검색과 지식 활용, 상담·챗봇, 반복 업무 자동화, 에이전트 기능 가운데 필요한 요소를 구성하고 품질을 검증하는 방법과 운영 방식까지 함께 설계합니다.',
  },
  {
    question: '프로젝트는 어떤 방식으로 진행되나요?',
    answer:
      '문의 내용과 현재 환경을 확인한 뒤 요구사항과 우선순위, 범위, 일정, 협업 방식을 정리합니다. 설계·구현·검토를 반복하고, 프로젝트에 따라 배포와 운영 인수인계까지 이어갑니다.',
  },
];
